export default "data:image/gif;base64,R0lGODlhEgAMAPEAAP///37A7uXl5QAAACH5BAAAAAAALAAAAAASAAwAAAIplB15u+CQwpvOzEinfThXcSVeFZXmiaYRyInj5nQeDLkzG9sZI6z8UQAAOw=="